<div class="modal-header">
  <h4 class="modal-title">Change Password</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<ng-container *ngIf="formGroup.statusChanges | async"></ng-container>
<form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
  <div class="modal-body">
    <div class="form-row">
      <div class="col">
        <label for="oldPassword">Old Password</label>
        <input id="oldPassword" formControlName="oldPassword" type="password" class="form-control" />
        <div class="invalid-feedback" *ngIf="
            oldPassword.invalid && (oldPassword.dirty || oldPassword.touched)
          ">
          required.
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="newPassword">New Password</label>
        <input id="newPassword" formControlName="newPassword" type="password" class="form-control" />
        <div class="invalid-feedback" *ngIf="
            newPassword.invalid && newPassword.errors && (newPassword.dirty || newPassword.touched)
          ">
          <ng-container *ngIf="newPassword.errors['required']">required.</ng-container>
          <ng-container *ngIf="newPassword.errors['pattern']">
            Password must:
            <ul>
              <li>Be 12-20 characters long</li>
              <li>Include at least one number</li>
              <li>Include at least one uppercase letter</li>
              <li>Include at least one lowercase letter</li>
              <li>Include at least one special character</li>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="newPasswordRepeat">New Password Repeat</label>
        <input id="newPasswordRepeat" formControlName="newPasswordRepeat" type="password" class="form-control" />
        <div class="invalid-feedback" *ngIf="
            newPasswordRepeat.invalid &&
            (newPasswordRepeat.dirty || newPasswordRepeat.touched)
          ">
          required.
        </div>
        <div *ngIf="formGroup.errors?.['retypedNewPassword'] && (newPasswordRepeat.dirty || newPasswordRepeat.touched)"
          class="invalid-feedback d-block">
          New passwords do not match.
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" [disabled]="formGroup.invalid" class="btn btn-primary m-2 float-right" ngbAutofocus>
      Update
    </button>
  </div>
</form>